import { InputGroupInput, InputProps } from '@e2n/ui';
import { maskitoDate } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { useTranslation } from 'react-i18next';

const options = maskitoDate({ mode: 'dd/mm/yyyy', locale: 'de-DE' });

export function DateInputGroupInput({
  className,
  value,
  onChange,
  ...props
}: InputProps) {
  const maskito = useMaskito({ options });
  const { t } = useTranslation();

  return (
    <InputGroupInput
      {...props}
      ref={maskito}
      className={`text-start h-10 ${className ?? ''}`}
      value={value}
      onChange={onChange}
      placeholder={props.placeholder ?? t('general.date.dateInput.placeholder')}
      type="text"
    />
  );
}
